import React from "react";
import { useSelector } from "react-redux";

export const FilterSectionCollapse = (props) => {
  const { sectionName, focusSection, handleCollapse } = props;
  let sectionClassName = sectionName + "_filter_wrapper";

  let filterStatement = useSelector(
    (state) => state.filter.filterStatementList[sectionName]
  );

  let filterResultList = useSelector((state) => state.filter.filterResultList);

  return (
    <div className="collapse_control">
      <div className="collapse_content">
        <div className="collapse_content_header">
          <div className="collapse_content_title">
            {sectionName.replace(sectionName[0], sectionName[0].toUpperCase())}
          </div>
          <div
            className={`collapse_content_search_result ${
              focusSection == sectionClassName
                ? ""
                : "collapse_content_search_result_hidden"
            }`}
          >
            {filterResultList.loading
              ? "Loading..."
              : filterResultList.filterResultError
              ? filterResultList.filterResultError
              : filterResultList.totalResults + " FOUND"}
          </div>
        </div>
        <div
          className={`collapse_content_filter_status ${
            focusSection == sectionClassName ? "collapse_status_hidden" : ""
          }`}
        >
          {filterStatement}
        </div>
      </div>
      <div
        onClick={(e) => handleCollapse(e)}
        className={`${sectionClassName} collapse_btn ${
          focusSection == sectionClassName ? "btn_active" : ""
        }`}
      ></div>
    </div>
  );
};
